import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { createUrl } from '@on3/ui-lib/utils/url';
import clsx from 'clsx';

import styles from './StarRanking.module.scss';

interface StarRankingProps {
  nationalRank?: number | null;
  positionRank?: number | null;
  stateRank?: number | null;
  stateAbbr?: string | null;
  positionAbbr?: string | null;
  sport?: string | null;
  year?: number | string | null;
  isConsensus?: boolean;
  className?: string;
  useSiteColor?: boolean;
  returnEmpty?: boolean;
}

export const StarRanking = ({
  nationalRank,
  positionRank,
  stateRank,
  stateAbbr,
  positionAbbr,
  useSiteColor = true,
  sport,
  year,
  className,
  isConsensus,
  returnEmpty,
}: StarRankingProps) => {
  const { sportsData } = useSite();
  const hasRankings = nationalRank || positionRank || stateRank;

  if (!hasRankings && !returnEmpty) return null;

  const isIndustrySport = sportsData?.find(
    (sportData) => slugify(sportData?.name) === sport?.toLowerCase(),
  )?.isIndustryRankable;
  const rankingTypeUrl =
    isConsensus && isIndustrySport ? 'industry-player' : 'player';
  const sluggedState = slugify(stateAbbr);
  const sluggedPosition = slugify(positionAbbr);
  const baseLink = createUrl([
    'rivals',
    'rankings',
    rankingTypeUrl,
    sport,
    year,
  ]);

  return (
    <div className={clsx(styles.ranking, className)} data-ui="player-rankings">
      <dl>
        <dt aria-label="nationalRank Rank">Natl</dt>
        <dd>
          <Link href={baseLink} useSiteColor={useSiteColor}>
            {nationalRank || '-'}
          </Link>
        </dd>
      </dl>
      <dl>
        <dt aria-label="Postion Rank">Pos</dt>
        <dd>
          <Link
            href={
              baseLink && sluggedPosition
                ? `${baseLink}?position=${sluggedPosition}`
                : null
            }
            useSiteColor={useSiteColor}
          >
            {positionRank || '-'}
          </Link>
        </dd>
      </dl>
      <dl>
        <dt aria-label="State Rank">St</dt>
        <dd>
          <Link
            href={
              baseLink && sluggedState
                ? `${baseLink}?state=${sluggedState}`
                : null
            }
            useSiteColor={useSiteColor}
          >
            {stateRank || '-'}
          </Link>
        </dd>
      </dl>
    </div>
  );
};
